import React from 'react';
import { GlassCard } from './ui/GlassCard';

interface TaskDetailsModalShellProps {
  children: React.ReactNode;
  footer: React.ReactNode;
  header: React.ReactNode;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  tone?: 'blue' | 'pink';
  zIndexClassName?: string;
}

export const TaskDetailsModalShell: React.FC<TaskDetailsModalShellProps> = ({
  children,
  footer,
  header,
  onSubmit,
  tone = 'pink',
  zIndexClassName = 'z-[120]',
}) => {
  const content = (
    <>
      <div
        className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-4 py-4 overscroll-contain md:px-8 md:py-6"
        data-testid="task-details-modal-body"
      >
        {children}
      </div>
      <div
        className="shrink-0 border-t border-white/5 bg-slate-950/60 px-4 py-3 [padding-bottom:max(0.75rem,env(safe-area-inset-bottom))] md:px-8 md:py-5"
        data-testid="task-details-modal-footer"
      >
        {footer}
      </div>
    </>
  );

  return (
    <div
      className={`fixed inset-0 ${zIndexClassName} flex items-center justify-center overflow-hidden bg-slate-950/90 p-2 [padding-top:max(0.5rem,env(safe-area-inset-top))] [padding-bottom:max(0.5rem,env(safe-area-inset-bottom))] backdrop-blur-3xl sm:p-4 md:p-6`}
      data-testid="task-details-modal-overlay"
    >
      <GlassCard
        className={`flex h-full max-h-full w-full max-w-4xl flex-col overflow-hidden !p-0 animate-fade-in-up sm:h-auto sm:max-h-[calc(100dvh-2rem)] md:max-h-[calc(100dvh-3rem)] ${
          tone === 'blue'
            ? 'border-brand-neonBlue/30 shadow-neon'
            : 'border-brand-neonPink/30 shadow-neon-pink'
        } rounded-[24px] md:rounded-[40px]`}
      >
        <div
          className="shrink-0 border-b border-white/5 px-4 py-4 md:px-8 md:py-6"
          data-testid="task-details-modal-header"
        >
          {header}
        </div>

        {onSubmit ? (
          <form className="flex min-h-0 flex-1 flex-col" onSubmit={onSubmit}>
            {content}
          </form>
        ) : (
          <div className="flex min-h-0 flex-1 flex-col">{content}</div>
        )}
      </GlassCard>
    </div>
  );
};
